export const FINANCE_RECONCILIATION_UPDATED_EVENT = 'finance-reconciliation-updated';
export const FINANCE_RECONCILIATION_UPDATED_KEY = 'finance-reconciliation-updated-at';

export const notifyFinanceReconciliationUpdated = () => {
  if (typeof window === 'undefined') return;

  window.dispatchEvent(new Event(FINANCE_RECONCILIATION_UPDATED_EVENT));

  try {
    window.localStorage.setItem(FINANCE_RECONCILIATION_UPDATED_KEY, String(Date.now()));
  } catch {
    // Some browsers can block localStorage; the in-page event above still refreshes the current app.
  }
};
